export default {
  title01: "Thời tiết hiện tại",
  title02: "24 tiếng",
  title03: "xem dự báo thời tiết trong 10 ngày",
  title04: "AQI",
  title05: "xem mọi thông tin",
  title06: "bình minh và hoàng hôn",
  title07: "pha Mặt Trăng",
  title08: "Trăng tròn kế tiếp",
  title09: "Trăng mới kế tiếp",
  title10: "Ngày",
  title11: "Đêm",
  title12: "Mặt Trời lên",
  title13: "Mặt Trời lặn",
  title14: "lúc Trăng lên",
  title15: "lúc Trăng lặn",
  title16: "nguồn",
  title17: "Bắt đầu",
  title18: "Kết thúc",
  title19: "sử dụng vị trí hiện tại",
  title20: "tìm thành phố",
  title21: "Cảm giác thật",
  title22: "cảm giác thật trong bóng râm",
  title23: "Hiện tại",
  title24: "hôm nay",
  title25: "Chủ nhật",
  title26: "Thứ hai",
  title27: "Thứ ba",
  title28: "Thứ tư",
  title29: "Thứ năm",
  title30: "Thứ sáu",
  title31: "Thứ bảy",
  title32: "đang tải...",
  title33: "Hiện tại",
  title34: "giờ",
  title35: "hàng ngày",
  title36: "Mặt Trời và Mặt Trăng",
  title37: "Chất lượng không khí",
  title38: "Liên hệ tới : xlf550402@gmail.com",
  title39: "Thỏa thuận về quyền riêng tư",
  title40: " Bản quyền thuộc © comfortweather.com 2020 - 2025. Được bảo lưu mọi quyền.",
  title41: " Dữ liệu được cung cấp bởi",
  title42: "Nhiệt độ cao nhất",
  title43: "Nhiệt độ thấp nhất",
  title44: "Chấp nhận",
  title45: "Cảm ơn bạn đã sử dụng ComfortWeather! Để bảo vệ tốt hơn quyền lợi hợp pháp của bạn, vui lòng đọc kỹ ",
  title46: "Chính sách bảo mật",
  title47: " trước khi sử dụng.",
  title48: "",
  title49: "Liên hệ tới : xyjph123@gmail.com",
  title50: " Bản quyền thuộc © 24hweather.com 2020 - 2025. Được bảo lưu mọi quyền.",
  title51: "Cảm ơn bạn đã sử dụng 24hweather! Để bảo vệ tốt hơn quyền lợi hợp pháp của bạn, vui lòng đọc kỹ ",
};
